<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <div class="vx-card">
                <div class="vx-card__header">
                    <div class="vx-card__title">
                        <h4 class="mb-4">All transactions</h4>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col mb-base">
                        <vs-input id="search-box" v-on:input="filterChanged" icon="search" size="large"
                                  v-model="searchInput"
                                  label-placeholder="Search"
                                  class="ml-6 mt-6"/>
                    </div>
                    <div class="vx-col mb-base grid-filter-icon-wrapper" v-on:click="showFilters = !showFilters">
                        <feather-icon icon="FilterIcon" svgClasses="w-6 h-6 mt-6"/>
                    </div>
                </div>
                <div class="vx-row ag-grid-columns-filter-wrapper" v-bind:class="{ show: showFilters}">
                    <div class="vx-col ml-6">
                            <span v-for="(column, index) in columnsFilter" v-bind:key="index"
                                  class="filter-checkbox-wrapper mb-2">
                                <vs-checkbox v-model="column.show"
                                             @change="setColumnsVisibility()">{{column.name}}</vs-checkbox>
                            </span>
                    </div>
                </div>
                <ag-grid-vue
                    class="ag-theme-material w-100 my-4 ag-grid-table"
                    :columnDefs="transactionsListColumns"
                    :rowData="transactionsData"
                    :defaultColDef="defaultColDef"
                    :gridOptions="gridOptions"
                    :components="transactionComponents"
                    rowSelection="multiple"
                    colResizeDefault="shift"
                    :animateRows="true"
                    :pagination="true"
                    :paginationPageSize="paginationPageSize"
                    :suppressPaginationPanel="true"
                    overlayNoRowsTemplate=" "
                    v-on:gridReady="setGridSize($event)">
                </ag-grid-vue>

                <vs-pagination
                    :total="totalPages"
                    :max="paginationMaxSize"
                    v-model="currentPage"/>
            </div>

        </div>
    </div>
</template>

<script>

    import RestService from '../services/RestService';

    import {AgGridVue} from 'ag-grid-vue';
    import '../assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import CellRendererValue from './cell-renderer/CellRendererValue'
    import CellRendererDate from './cell-renderer/CellRendererDate'
    import CellRendererDescription from './cell-renderer/CellRendererDescription'

    export default {
        name: "transactions-admin",

        async beforeMount() {
            const allTransactionsResponse = await RestService.getAllTransactions();
            if (allTransactionsResponse.success) {
                this.listOfTransactions = allTransactionsResponse.data;

                this.listOfTransactions = this.listOfTransactions.map(r => {
                    r.user.fullName = r.user.first_name + ' ' + r.user.last_name;
                    return r;
                });
            }
        },
        computed: {
            transactionsData() {
                return this.listOfTransactions;
            },
            paginationPageSize() {
                return 10; // TODO maybe change
            },
            paginationMaxSize() {
                if (this.gridApi) {
                    let pagesNr = this.gridApi.paginationGetTotalPages();
                    return pagesNr < 8 ? pagesNr + 1 : 7; // TODO maybe change this
                } else
                    return 1;
            },
            totalPages() {
                if (this.gridApi)
                    return this.gridApi.paginationGetTotalPages();
                else
                    return 0;
            },
            currentPage: {
                get() {
                    if (this.gridApi)
                        return this.gridApi.paginationGetCurrentPage() + 1;
                    else
                        return 1;
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1);
                }
            }
        },
        components: {
            AgGridVue,

            CellRendererValue,
            CellRendererDate,
            CellRendererDescription
        },
        methods: {
            setGridSize(params) {
                if (window.innerWidth > 1024)
                    params.api.sizeColumnsToFit();
                this.gridOptions.api.setDomLayout('autoHeight');
            },

            filterChanged() {
                this.gridApi.setQuickFilter(document.getElementById('search-box').value);
            },

            setColumnsVisibility() {
                this.columnsFilter.forEach(c => {
                    this.gridOptions.columnApi.setColumnVisible(c.id, c.show);
                });
                // TODO this needs optimization
                if (window.innerWidth > 1024)
                    this.gridApi.sizeColumnsToFit();
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.columnsFilter = this.transactionsListColumns.map(c => {
                return {id: c.field, name: c.headerName, show: true};
            });
        },
        data() {
            return {
                gridApi: null,
                gridOptions: {},
                listOfTransactions: null,
                transactionsListColumns: [
                    {
                        headerName: 'Created at',
                        field: 'created_at',
                        cellRendererFramework: 'CellRendererDate',
                        //width: 300
                    },
                    {
                        headerName: 'Value',
                        field: 'value',
                        cellRendererFramework: 'CellRendererValue'
                    },
                    {
                        headerName: 'Description',
                        field: 'description',
                        cellRendererFramework: 'CellRendererDescription'
                        //width: 350
                    },
                    {
                        headerName: 'Full name',
                        field: 'user.fullName',
                        //width: 350
                    },
                    {
                        headerName: 'User\'s email',
                        field: 'user.email',
                        //width: 350
                    }

                ],
                transactionComponents: [
                    CellRendererDate,
                    CellRendererValue
                ],
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                columnsFilter: [],
                showFilters: false,
                searchInput: ''
            }
        }
    }
</script>

<style scoped>

</style>
